import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getOpenInAppUrl } from '../../../helpers/serverRenderingUtils';
import { receivePageMetadata } from '../../pageMetadata';
import CallJoin from '../CallJoin/index.tsx';

const FACEBOOK_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/GenericRWFShare_Facebook.png';
const TWITTER_SOCIAL_IMAGE =
  'https://d12xoj7p9moygp.cloudfront.net/images/GenericRWFShare_Twitter.png';

const mapStateToProps = ({ user }, { location: { pathname, search } }) => {
  const inviteCode = pathname.substring(pathname.lastIndexOf('/') + 1);
  return {
    openInAppUrl: getOpenInAppUrl(`${pathname}${search}`),
    user,
    inviteCode,
  };
};

const mapDispatchToProps = dispatch => ({
  setPageMetadata: () => {
    dispatch(
      receivePageMetadata({
        image: FACEBOOK_SOCIAL_IMAGE,
        twitterImage: TWITTER_SOCIAL_IMAGE,
      })
    );
  },
  onPressDoneRecordingConfirmation: isUserLoggedIn => {
    if (isUserLoggedIn) {
      dispatch(push('/dashboard'));
    } else {
      dispatch(push('/signup?redirectedFrom=rwf'));
    }
  },
});

function CallJoinContainer({
  setPageMetadata,
  openInAppUrl,
  user,
  inviteCode,
  onPressDoneRecordingConfirmation,
}) {
  const [isPageMetadataSet, setIsPageMetadataSet] = useState(false);
  useEffect(() => {
    if (!isPageMetadataSet) {
      setPageMetadata();
      setIsPageMetadataSet(true);
    }
  }, [setPageMetadata, isPageMetadataSet]);
  return (
    <CallJoin
      openInAppUrl={openInAppUrl}
      user={user && user.user ? user.user : null}
      inviteCode={inviteCode}
      onPressDoneRecordingConfirmation={onPressDoneRecordingConfirmation}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CallJoinContainer);
